import {Component, effect, inject, output, signal} from '@angular/core'
import {email, form, FormField, required} from '@angular/forms/signals'
import {MatButton} from '@angular/material/button'
import {MatDialog} from '@angular/material/dialog'
import {MatIcon} from '@angular/material/icon'
import {
  MatError,
  MatFormField,
  MatInput,
  MatLabel
} from '@angular/material/input'
import {MatDivider} from '@angular/material/list'
import {CameraDialog} from '@samtycke/camera'
import {filter} from 'rxjs'
import {IUser} from '../../general/types'
import {UserService} from '../../services/user-service'

@Component({
  selector: 'smt-profile',
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    FormField,
    MatDivider,
    MatButton,
    MatIcon,
    MatError
  ],
  templateUrl: './profile.html',
  styleUrl: './profile.scss',
})
export class Profile {

  constructor() {
    effect(() => {
      this.model.set(this.userService.user())
    })
  }

  private readonly dialog = inject(MatDialog)
  private readonly userService = inject(UserService)
  public image = output<string>()

  public model = signal<IUser>({
    id: '',
    name: '',
    phone: '',
    email: '',
    facebook: '',
    instagram: '',
    linkedIn: '',
    unsplash: '',
    web: '',
    thankYouMessage: '',
    profilePicture: '',
    // TODO Is this a security risk?
    scopes: [],
    firstTimeLogin: false,
    showTutorials: {
      newShareProject: true,
      qrCode: true,
      linkSign: true,
      quickStart: true
    }
  })

  public form = form(this.model, p => {
    required(p.name, {message: 'Fyll i ett namn.'})
    required(p.email, {message: 'Fyll i en epostadress.'})
    email(p.email, {message: 'Epostadressen är felaktigt ifylld.'})
  })

  public startCamera() {
    this.dialog.open<CameraDialog, null, string>(CameraDialog)
      .afterClosed()
      .pipe(
        filter(Boolean)
      )
      .subscribe(image => this.image.emit(image))
  }
}
